import React, { Component } from 'react';
import { withNamespaces } from 'react-i18next';
import { withRouter } from 'react-router-dom';

import { Container, Button } from 'reactstrap';
import UpdatePlcSafetyEventForm from '../../components/Forms/UpdatePlcSafetyEventForm';

class PlcSafetyEventDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      event: this.props.location.state || null,
    };
  }

  componentDidMount() {
    if (!this.state.event) {
      this.props.history.push('/plcSafetyEvents');
    }
  }

  goBack(event) {
    event.preventDefault();
    this.props.history.push('/plcSafetyEvents');
  }

  render() {
    const { event } = this.state;
    if (!event) return null;
    return (
      <div className="user-management">
        <Container fluid>
          <Button className="btn btn-primary waves-effect waves-light usersButtons" onClick={(event) => this.goBack(event)}>
            <i className="fas fa-arrow-left"></i>
          </Button>
          <UpdatePlcSafetyEventForm event={event} />
        </Container>
      </div>
    );
  }
}

export default withRouter(withNamespaces()(PlcSafetyEventDetails));
